import fetch from '@/utils/fetch'

// 获取验证码图片
export function getImgCode () {
  return fetch({
    url: '/ows/member/line-captcha/create',
    method: 'post'
  })
}

// 发送短信验证码
export function messageAuthentication (data) {
  return fetch({
    url: '/ows/member/sendCode',
    method: 'post',
    data
  })
}

// 用户注册
export function userRegister (data) {
  return fetch({
    url: '/ows/member/register',
    method: 'post',
    data
  })
}

// 用户登录 POST /pc/user/login
export function userLogin (data) {
  return fetch({
    url: '/auth/ows/user/token',
    method: 'post',
    data
  })
}

// 忘记密码
export function forgotPassword (data) {
  return fetch({
    url: '/ows/member/modifyUserPassword',
    method: 'post',
    data
  })
}

// 会员条款，免责声明
export function page (data) {
  return fetch({
    url: '/bms/protocol/page',
    method: 'POST',
    data
  })
}

// 官网用户手机号获取token
export function codeLogin (data) {
  return fetch({
    url: '/auth/ows/user/verificationCodetoken',
    method: 'POST',
    data
  })
}
